import React from 'react';

/**
 * Komponen untuk meng-inject Google Fonts dan global CSS animations
 */
const FontStyle = () => (
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');
        body { font-family: 'Outfit', sans-serif; }
        
        /* Scrollbar styling */
        ::-webkit-scrollbar { width: 6px; height: 6px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
        .dark ::-webkit-scrollbar-thumb { background: #475569; }

        /* Animations */
        @keyframes slideUp {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
        }
        .animate-slide-up {
            animation: slideUp 0.3s ease-out forwards;
        }
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        .animate-fade-in {
            animation: fadeIn 0.3s ease-out forwards;
        }

        /* Divine Tier Gradient Animation - Diagonal, Slow, Silver-Cyan-Magenta */
        @keyframes divineGradient {
            0% { background-position: 0% 0%; }
            50% { background-position: 100% 100%; }
            100% { background-position: 0% 0%; }
        }
        .divine-badge {
            background: linear-gradient(
                135deg, 
                #c0c0c0,  /* Silver */
                #06b6d4,  /* Cyan */
                #ec4899,  /* Magenta */
                #c0c0c0,  /* Silver */
                #06b6d4,  /* Cyan */
                #ec4899   /* Magenta */
            );
            background-size: 300% 300%;
            animation: divineGradient 6s ease infinite;
        }
    `}</style>
);

export default FontStyle;
